module.exports = __webpack_public_path__ + "static/media/card.3d3f6e32.jpg";